module.exports = __webpack_public_path__ + "static/media/KaTeX_Caligraphic-Regular.0ef0f2e3.woff2";